import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'Abstract' },
  { name: 'Accession Number' },
  { name: 'All Metadata' },
  { name: 'Article Number' },
  { name: 'Article Page Number' },
  { name: 'Author Affiliations' },
  { name: 'Author Keywords' },
  { name: 'Author ORCID' },
  { name: 'Authors' },
  { name: 'Document Title' },
  { name: 'DOI' },
  { name: 'Full Text & Metadata' },
  { name: 'Full Text Only' },
  { name: 'Funding Agency' },
  { name: 'Index Terms' },
  { name: 'IEEE Terms' },
  { name: 'INSPEC Controlled Terms' },
  { name: 'INSPEC Non-Controlled Terms' },
  { name: 'ISBN' },
  { name: 'ISSN' },
  { name: 'Issue' },
  { name: 'Mesh_Terms' },
  { name: 'Parent Publication Number' },
  { name: 'Publication Number' },
  { name: 'Publication Title' },
  { name: 'Standard Number' },
  { name: 'Standards Dictionary Terms' },
  { name: 'Standards ICS Terms' }
]

const defaultSyntaxGuideUrl = 'https://ieeexplore.ieee.org/Xplorehelp/searching-ieee-xplore/command-search'
const MAX_TERMS = 20
const nonAlphanumericSpaceRE = new RegExp('[^a-zA-Z0-9\\s]', 'g')

class IeeexploreEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('IEEE Xplore')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  mapOperator (operator) {
    return { op: operator.toUpperCase(), spaces: true }
  }
  formulateQuery (query) {
    return 'https://ieeexplore.ieee.org/search/searchresult.jsp?action=search&matchBoolean=true&newsearch=true&queryText=' + query
  }
  formTerm (text, isNegative, addQuotes, fieldSpecifier) {
    let r = ''
    if (isNegative) {
      r += 'NOT '
    }
    if (fieldSpecifier && fieldSpecifier.length > 0) {
      r += '"' + fieldSpecifier + '":'
    }
    if (addQuotes || text.match(nonAlphanumericSpaceRE)) {
      r += `"${text}"`
    } else {
      r += text
    }
    return encodeURIComponent(r)
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    const r = m ? [m] : []
    if (this.countTerms(queryGraphData) > MAX_TERMS) {
      r.push(this.formatErrorMessage('termLimit', MAX_TERMS))
    }
    return r
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default IeeexploreEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/IeeexploreEngine.js